<template>
  <div class="supplierMag">
    <el-container>
      <el-header>
        <!-- <div style="width: 100%;background: #D5E7ED;">
          <el-tabs v-model="activeName" type="card" @tab-click="handleTabClick" style="width: 100%">
            <el-tab-pane label="全部" name="first"></el-tab-pane>
            <el-tab-pane label="待审核" name="second"></el-tab-pane>
            <el-tab-pane label="已通过" name="third"></el-tab-pane>
            <el-tab-pane label="已驳回" name="fourth"></el-tab-pane>
          </el-tabs>
        </div>-->
        <!-- <el-form ref="form" :model="Contractform" :inline="true">
          <el-row>
            <el-col :span="6">
              <el-form-item label="公司名称" label-width="120px">
                <el-input
                  v-model="Contractform.companyName"
                  placeholder="-请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="法人姓名" label-width="120px">
                <el-input
                  v-model="Contractform.legalPerson"
                  placeholder="-请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="法人电话" label-width="120px">
                <el-input
                  v-model="Contractform.workPhone"
                  placeholder="-请输入"
                ></el-input>
              </el-form-item>
            </el-col>

            <div v-if="showAdvanceFilter">
              <el-col :span="6">
                <el-form-item label="联系人" label-width="120px">
                  <el-input
                    v-model="Contractform.contactName"
                    placeholder="-请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="联系人电话" label-width="120px">
                  <el-input
                    v-model="Contractform.contactPhone"
                    placeholder="-请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="合作单位状态" label-width="120px">
                  <el-select
                    v-model="Contractform.status"
                    placeholder="请选择"
                    default-first-option
                  >
                    <el-option label="全部" value></el-option>
                    <el-option label="已启用" value="1"></el-option>
                    <el-option label="已停用" value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="审核状态" label-width="120px">
                  <el-select
                    v-model="Contractform.approveStatus"
                    placeholder="请选择"
                    default-first-option
                  >
                    <el-option label="全部" value></el-option>
                    <el-option label="已保存" value="0"></el-option>
                    <el-option label="已撤回" value="1"></el-option>
                    <el-option label="待审批" value="2"></el-option>
                    <el-option label="已通过" value="3"></el-option>
                    <el-option label="已拒绝" value="4"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </div>
            <el-col :span="showAdvanceFilter ? 6 : 6">
              <div class="handlePanel">
                <el-button type="primary" icon @click="handleClick()"
                  >查询</el-button
                >
                <el-button type="info" icon @click="clearSearchConditions"
                  >重置</el-button
                >
                <el-button type="text" @click="moreScreen">{{
                  showAdvanceFilter ? "收起" : "高级筛选"
                }}</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form> -->
        <el-col :span="24" style="padding: 0 20px">
          <div class="operatePanel">
            <el-button
              type="primary"
              v-if="false"
              icon="el-icon-plus"
              @click="createSupplierA()"
              >提交资料</el-button
            >
            <el-button
              type="primary"
              v-if="btnAuthorize.modifyBtn.btnEnable"
              icon="el-icon-edit"
              @click="editSupplierA()"
              >修改</el-button
            >
            <el-button
              type="primary"
              v-if="btnAuthorize.callback.btnEnable"
              icon="el-icon-minus"
              @click="callbackSupplier()"
              >撤回</el-button
            >
          </div>
        </el-col>
      </el-header>
      <el-main ref="main">
        <el-table
          ref="multipleTable"
          :data="tableData"
          border
          size="mini"
          style="width: 100%"
          height="100%"
          @selection-change="handleSelectionChange"
          @row-click="rowClicked"
          @cell-dblclick="SupplierDetail"
          :row-class-name="setRowClassName"
        >
          <el-table-column type="selection" width="54"></el-table-column>
          <el-table-column
            v-for="(item, index) in tableColumnDatas"
            :key="index"
            :prop="item.class"
            :label="item.labelName"
            :sortable="item.sortEnable"
            show-overflow-tooltip
          >
            <!-- <template slot-scope="scope">
              <span v-if="item.isNumFilter">{{scope.row[scope.column.property]|numFilter}}</span>
              <span v-else>{{scope.row[scope.column.property]}}</span>
            </template> -->
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer>
        <div style="display: flex; justify-content: space-between">
          <span
            style="
              color: #666666;
              font-size: 14px;
              line-height: 32px;
              margin-top: 16px;
            "
            >显示{{
              totalCount > 0
                ? (currentPage - 1) * pageSize +
                  1 +
                  "-" +
                  (currentPage * pageSize > totalCount
                    ? totalCount
                    : currentPage * pageSize)
                : "0"
            }}，共{{ totalCount }}条记录</span
          >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[20, 30, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          ></el-pagination>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import {
  updateSupplierStatus, //更新供应商审批启用状态
  getSupplierAList, //获取供应商列表接口
} from "../../services/supplierMagServices";
import { recallApproveItemFun } from "@/page/approveComponents/approve";

export default {
  name: "supplierMag",

  props: {
    menuCode: {
      type: String,
    },
  },
  data() {
    return {
      activeName: "first",
      orgId: 0, //存储组织id
      selectItems: [], //记录选中的供应商
      currentUserId: "", //当前登录用户id
      //查询条件form
      Contractform: {
        companyName: "", //公司名称
        contactName: "", //联系人
        contactPhone: "", //联系人电话
        legalPerson: "", //法人
        status: "", //供应商状态
        workPhone: "", //公司电话
        topType: "bType", //供应商类型
      },
      tableColumnDatas: [
        { class: "companyName", labelName: "公司名称", sortEnable: false },
        // { class: "typeDisplayName", labelName: "分类", sortEnable: false },
        { class: "legalPerson", labelName: "法人姓名", sortEnable: false },
        {
          class: "workPhone",
          labelName: "办公电话",
          sortEnable: false,
        },
        { class: "contactName", labelName: "联系人姓名", sortEnable: false },
        { class: "contactPhone", labelName: "联系人电话", sortEnable: false },
        { class: "publicBank", labelName: "开户行", sortEnable: false },
        {
          class: "publicBankNumber",
          labelName: "开户行行号",
          sortEnable: false,
        },
        {
          class: "publicCompanyName",
          labelName: "发票抬头",
          sortEnable: false,
        },
        {
          class: "publicTaxAccount",
          labelName: "纳税人识别号",
          sortEnable: false,
        },
        { class: "statusDisName", labelName: "供应商状态", sortEnable: false },
        {
          class: "approveStatusDisName",
          labelName: "供应商审核状态",
          sortEnable: false,
        },
      ],
      showAdvanceFilter: false,
      currentPage: 1,
      pageSize: 20,
      totalCount: 0,
      tableData: [],
      btnAuthorize: {
        addBtn: { key: "create", btnEnable: false },
        modifyBtn: { key: "update", btnEnable: false },
        callback: { key: "callback", btnEnable: false }, //撤回
      },
    };
  },
  mounted() {
    this.currentUserId = sessionStorage.getItem("currentUserId");
    this.orgId = sessionStorage.getItem("orgId");
  },
  methods: {
    handleTimestamp() {
      this.$forceUpdate();
    },
    onActive(menuCode) {
      this.currentPage = 1;
      this.$getRoleBtns(menuCode, this.btnAuthorize);
      this.initList(); //获取下拉列表  gaa 20200806
    },
    //点击查询
    handleClick() {
      this.currentPage = 1;
      this.initList();
    },
    //获取供应商列表
    initList() {
      let param = {
        supplierId: sessionStorage.getItem("supplierId"),
        topType: "bType",
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
      };
      // for (let key in this.Contractform) {
      //   if (this.Contractform[key] !== "") {
      //     param[key] = this.Contractform[key];
      //   }
      // }
      getSupplierAList(param, true)
        .then((res) => {
          if (res.code == 10000000) {
            this.dealTableData(res);
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {
          this.$message.error("系统异常");
        });
    }, //
    dealTableData(res) {
      this.tableData = res.data;
      this.tableHeight = this.$refs.main.$el.offsetHeight - 10;
      this.totalCount = res.total;
    }, //

    onSearch() {
      this.currentPage = 1;
      this.initList();
    },
    //重置查询条件
    clearSearchConditions() {
      for (let key in this.Contractform) {
        if (key != "tabIndex") {
          this.Contractform[key] = "";
        }
      }
      this.handleClick();
    }, //
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initList();
    }, //
    handleCurrentChange(page) {
      this.currentPage = page;
      this.initList();
    },
    //选择一条供应商
    handleSelectionChange(val) {
      this.selectItems = val;
      console.log(val);
    }, //
    setRowClassName({ row, rowIndex }) {
      if (row.isOverTime != 0) {
        return "overTimeMark";
      }
    }, //
    // 点击选中行
    rowClicked(row, event, column) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    //双击跳转供应商详情
    SupplierDetail(row, column, cell, event) {
      this.$refs.multipleTable.toggleRowSelection(row);
      let memberData = {};
      memberData.detailFlag = "C"; //详请 false 审核 true
      memberData.id = row.id; //选中行
      this.bus.$emit("navMenuChange", {
        routeId: "supplierDetail",
        routeParam: memberData,
      });
    },
    //tab页切换
    // handleTabClick(tab, event) {
    //   // console.log(tab, event);
    //   // this.clearSearchConditions();
    //   this.currentPage = 1;
    //   switch (this.activeName) {
    //     case "first":
    //       this.Contractform.tabIndex = "0";
    //       break;
    //     case "second":
    //       this.Contractform.tabIndex = "1";
    //       break;
    //     case "third":
    //       this.Contractform.tabIndex = "2";
    //       break;
    //     case "fourth":
    //       this.Contractform.tabIndex = "3";
    //       break;
    //     default:
    //       this.Contractform.tabIndex = "0";
    //       break;
    //   }
    //   this.initList();
    // },

    //跳转到创建录入乙方信息
    createSupplierA() {
      let memberData = {};
      memberData.editFlag = false; //新增标志为0
      memberData.topType = "bType"; // 供应商乙方
      // memberData.path = "order-list";
      this.bus.$emit("navMenuChange", {
        routeId: "addSupplierBPage",
        routeParam: memberData,
      });
    },
    //跳转到修改乙方信息
    editSupplierA() {
      if (this.selectItems.length != 1) {
        this.$alert("请选择一条数据", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      if (this.selectItems[0].approveStatus == 2) {
        this.$alert("待审批状态的供应商不允许修改", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      let memberData = {};
      memberData.editFlag = true; //编辑标志为1
      memberData.topType = "bType"; //0 供应商乙方
      memberData.id = this.selectItems[0].id; //选中行
      // memberData.path = "order-list";
      this.bus.$emit("navMenuChange", {
        routeId: "editSupplierBPage",
        routeParam: memberData,
      });
    },
    //启用供应商
    OpenSupplier(val) {
      if (this.selectItems.length != 1) {
        this.$alert("请选择一条数据", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      if (val == 0 && this.selectItems[0].status == 0) {
        this.$alert("该供应商已停用", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      if (val == 1 && this.selectItems[0].status == 1) {
        this.$alert("该供应商已启用", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }

      let msg = "确认启用该供应商吗?";
      let param = {
        id: this.selectItems[0].id,
        status: val, //sessionStorage.getItem("userCode"),
      };
      if (val == 0) {
        msg = "确认停用该供应商吗?";
      }
      this.$confirm(msg, "提示", {
        confirmButtonText: "确认",
      }).then(() => {
        updateSupplierStatus(param)
          .then((res) => {
            if (res.code == 10000000) {
              this.$alert("操作成功", "提示", {
                confirmButtonText: "确定",
              });
              this.handleClick();
            } else if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$message.error("网络请求失败");
          });
      });
    },
    //撤回合作单位
    callbackSupplier() {
      if (this.selectItems.length != 1) {
        this.$alert("请选择一条数据", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
       if (this.selectItems[0].approveStatus != 2) {
        this.$alert("只有待审批状态的供应商可以撤回", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      let param = {
        // currentUserId: 1 //sessionStorage.getItem("userCode"),
      };
      param.itemId = this.selectItems[0].id;
      param.type = "SUPPLIER";
      this.$confirm("确认撤回该条数据吗?", "提示", {
        confirmButtonText: "确认",
      }).then(async () => {
        let res = await recallApproveItemFun(param);
        if (res && res.code == 10000000) {
          this.$message.success("撤回成功");
          this.handleClick();
        }
      });
    },
    moreScreen() {
      this.showAdvanceFilter = !this.showAdvanceFilter;
      if (this.showAdvanceFilter) {
        this.tableHeight = this.$refs.main.$el.offsetHeight - 144 - 10;
      } else {
        this.tableHeight = this.$refs.main.$el.offsetHeight + 144 - 10;
      }
    },
  },
};
</script>

<style scoped >
/deep/.el-tabs__header {
  padding-right: 0 !important;
  background: #d5e7ed !important;
}
>>> .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background: #fff;
  color: #069dbc !important;
  border-bottom-color: #e4e7ed;
}
>>> .el-tabs__item:hover {
  color: #069dbc;
}
</style>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.el-container {
  padding-top: 0;
  .el-header {
    padding: 0;
    form {
      padding-right: 20px;
    }
  }
}
.supplierMag {
  height: 100%;
  background-color: white;
}
/deep/.el-tabs__header {
  padding-right: 0 !important;
  background: #d5e7ed !important;
}
.el-select {
  width: 100%;
}
.hide {
  display: none;
}

/deep/.overTimeMark {
  // background-color: #e9f4fa;
  .el-tooltip {
    color: #333333;
  }
}

/deep/.el-form-item__content {
  width: 60%;
}
/deep/.el-form-item {
  width: 100%;
}
/deep/.el-date-editor {
  width: 100% !important;
}
</style>
